/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { validate } from 'ember-validators';

/**
 * @param {String}                    ariaLabelledBy
 * @param {String}                    ariaLabel
 * @param {Boolean}                   bgReset
 * @param {Boolean}                   disabled
 * @param {Function}                  onChange
 * @param {String}                    placeholder
 * @param {Array<String>}             selected
 * @param {String}                    tagLabel
 * @param {String}                    validationType // https://github.com/offirgolan/ember-validators#usage
 * @param {Array}                     validationOptions // https://github.com/offirgolan/ember-validators#usage
 * @param {String}                    validationDescription // https://github.com/offirgolan/ember-validators#usage
 */
let TagsInput = (_class = class TagsInput extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "tagLabel", _descriptor, this);
    this.tagLabel = this.args.tagLabel ?? 'tag';
  }
  get _selected() {
    return this.args.selected?.map(item => ({
      value: item
    }));
  }
  showSearchAsValidatedTagOption(value) {
    if (this.args.validationType) {
      const validation = validate(this.args.validationType, value, this.args.validationOptions);
      const disabled = validation !== true;
      return [{
        value,
        disabled
      }];
    } else {
      return [{
        value
      }];
    }
  }
  handleKeyDown(select, event) {
    if (event && (event.key === 'Tab' || event.key === 'Enter') && select.isOpen) {
      event.preventDefault();
      if (select.results && select.results[0] && !select.results[0].disabled) {
        select.actions.choose(select.results[0], event);
      }
      select.actions.close(event);
      return false;
    }
  }
  handleChange(options = [], select) {
    const didRemoveAnOption = options.length < this.args.selected?.length;
    if (didRemoveAnOption) {
      select.actions && select.actions.open(); // refocus the TagsInput after removing a tag
    }

    this.args.onChange(options.map(opt => opt.value));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "tagLabel", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "showSearchAsValidatedTagOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showSearchAsValidatedTagOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleChange"), _class.prototype)), _class);
export { TagsInput as default };